export const selfieStates = {
  no_camera: "noCamera",
  no_access: "noAccess",
  take_selfie: "takeSelfie",
}